import React from 'react';
import Tooltip from 'rc-tooltip';
import { singularize } from 'inflection';

import styles from './styles';

const RecommendationList = ({ listItems, title }) => {
  const tooltipText = (
    <div className={styles.recommendationTooltip}>
      {listItems.map((listItem, idx) => (
        <div key={listItem + idx}>{listItem}</div>
      ))}
    </div>
  );

  return (
    <div className={`${styles.typeListItem} ${styles.hoverable}`}>
      <Tooltip destroyTooltipOnHide overlay={tooltipText} trigger={['hover']}>
        <span data-testid={`tooltip-${title}`}>
          <strong>{listItems.length}</strong> matching{' '}
          {listItems.length > 1 ? title : singularize(title)}
        </span>
      </Tooltip>
    </div>
  );
};

export default RecommendationList;
